/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { AccessRequestsAppAccessRule } from './AccessRequestsAppAccessRule';
import {
    AccessRequestsAppAccessRuleFromJSON,
    AccessRequestsAppAccessRuleFromJSONTyped,
    AccessRequestsAppAccessRuleToJSON,
} from './AccessRequestsAppAccessRule';

/**
 * 
 * @export
 * @interface GetAccessRequestsAppRulesMe200Response
 */
export interface GetAccessRequestsAppRulesMe200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetAccessRequestsAppRulesMe200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetAccessRequestsAppRulesMe200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<AccessRequestsAppAccessRule>}
     * @memberof GetAccessRequestsAppRulesMe200Response
     */
    result: Array<AccessRequestsAppAccessRule>;
}

/**
 * Check if a given object implements the GetAccessRequestsAppRulesMe200Response interface.
 */
export function instanceOfGetAccessRequestsAppRulesMe200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetAccessRequestsAppRulesMe200ResponseFromJSON(json: any): GetAccessRequestsAppRulesMe200Response {
    return GetAccessRequestsAppRulesMe200ResponseFromJSONTyped(json, false);
}

export function GetAccessRequestsAppRulesMe200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccessRequestsAppRulesMe200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': ((json['result'] as Array<any>).map(AccessRequestsAppAccessRuleFromJSON)),
    };
}

export function GetAccessRequestsAppRulesMe200ResponseToJSON(value?: GetAccessRequestsAppRulesMe200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': ((value.result as Array<any>).map(AccessRequestsAppAccessRuleToJSON)),
    };
}

